import React from 'react';
import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import Button from '@prisjakt/ui-button';
import T from '@prisjakt/ui-translate';
import { Column, GridRow } from '@prisjakt/ui/list/variants';
import { applyFilterAreaHeight } from '../../constants';

type Props = {
  count?: number;
  hasFiltered?: boolean;
  onClick: () => void;
  onClear?: () => void;
  canClear?: boolean;
};

const ApplyFilterButton = ({
  count = 0,
  hasFiltered = true,
  onClick,
  onClear,
  canClear = true,
}: Props) => (
  <ActionBar>
    <Column gap={parseFloat(layout.measurements.spacing050)}>
      <ProductCount>
        <T domain="filter" n={count}>
          result.n-products
        </T>
      </ProductCount>
      <GridRow gap={parseFloat(layout.measurements.spacing050)}>
        {onClear && (
          <Button
            color="tertiary"
            variant="outlined"
            onClick={onClear}
            disabled={!canClear}
          >
            <T domain="filter">button.clear-filter</T>
          </Button>
        )}
        <Button color="primary" onClick={onClick} disabled={!hasFiltered}>
          <T domain="filter">button.apply-filter</T>
        </Button>
      </GridRow>
    </Column>
  </ActionBar>
);

export default ApplyFilterButton;

export const ActionBar = styled.div`
  background-color: ${p => p.theme.actionBar.bg};
  box-shadow: ${p => p.theme.actionBar.boxShadow};
  color: ${p => p.theme.actionBar.fg};
  width: 100%;
  padding: 10px;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;

  /* Set explicit height in order to account for that height in the wrapper */
  height: ${applyFilterAreaHeight}px;

  ${media.largeUp`
    display: none;
  `}
`;

export const ProductCount = styled.div`
  text-align: center;
`;
